<template>
  <div class="content" ref="warterMark">
    <div class="title">电子证件</div>
    <div class="wrapper">
      <div class="logoArea">
        <div class="schoolLogo"></div>
        <div class="schoolMotto"></div>
      </div>
      <div class="contentArea">
        <div class="left">
          <p class="name">陈仁桐</p>
          <p class="department">财务部</p>
          <p class="tips">注意事项：</p>
          <p class="tip">1.本卡可证明本人身份，不得转借他人。</p>
          <p class="tip">2.本卡若有丢失，应即声明作废，并申请补发。</p>
          <p class="tip">3.本卡不得涂改，涂改者一律作废。</p>
          <p class="tip">4.离职时必须交回。</p>
        </div>
        <div class="right">
          <!-- <image id="headphoto" :src="require('@/assets/zhicheng/t-photo.png')"></image> -->
          <img
            id="headphoto"
            :src="require('@/assets/zhicheng/t-photo.png')"
            alt=""
          />
          <p class="jobNum">工号100011235</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Watermark from '../../../utils/warterMark';

// import watermark from '../../../components/jm-watermark/jm-watermark.vue'
export default {
  // components: { watermark } ,
  data() {
    return {
      updateTime: '',
    };
  },
  onLoad() {
    // this.initCanvas()
  },
  created() {
    this.nowTimes();
  },
  mounted() {
    //this.initCanvas()
    Watermark.set(this.updateTime, this.$refs.warterMark);
  },
  methods: {
    //显示当前时间（年月日时分秒）
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? '0' + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? '0' + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? '0' + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? '0' + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? '0' + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      this.updateTime =
        year + '/' + month + '/' + date + ' ' + hh + ':' + mm + ':' + ss;
    },
    nowTimes() {
      this.timeFormate(new Date());
    },
  },
};
</script>

<style lang="scss" scoped>
uni-page-body {
  height: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #1374df;
  width: 100%;
  height: auto;
  min-height: 100vh;
  position: relative;
  .title {
    background: rgb(19, 116, 223);
    color: #fff;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}

.logo {
  height: 200rpx;
  width: 200rpx;
  margin-top: 200rpx;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50rpx;
}

.text-area {
  display: flex;
  justify-content: center;
}

.title {
  font-size: 36rpx;
  color: #8f8f94;
}
.content .wrapper {
  width: 92%;
  min-height: 32.4%;
  background-color: #fff;
  // position: absolute;
  // top: 15px;
  border-radius: 10px;
}
.content .wrapper .logoArea {
  width: 100%;
  margin-top: 13px;
  height: 32px;
  display: inline-flex;
  justify-content: flex-start;
  flex-direction: row;
  position: relative;
}
.content .wrapper .logoArea .schoolLogo {
  width: 204px;
  height: 32px;
  background: url(../../../assets/zhicheng/schoolLogo.png) no-repeat center;
  background-size: auto 100%;
  margin-left: 25px;
}
.content .wrapper .logoArea .schoolMotto {
  width: 106px;
  height: 23px;
  background: url(../../../assets/zhicheng/schoolMotto.png) no-repeat right;
  background-size: auto 100%;
  position: absolute;
  right: 0px;
  top: 4px;
}
.content .wrapper .contentArea {
  width: 100%;
  min-height: 138px;
  margin-top: 10px;
  position: relative;
  margin-bottom: 15px;
  /* 		display: flex;
		flex-direction: row;
		justify-content: flex-start; */
}
.content .wrapper .contentArea .left {
  width: 250px;
  height: 100%;
  padding-left: 25px;
  color: rgba(51, 51, 51, 1);
}
.left .name {
  margin-top: 10px;
  font-size: 17px;
  font-weight: 500;
}
.left .department,
.left .tips {
  font-size: 13px;
  margin-top: 5px;
}
.left .tips {
  font-size: 13px;
  margin-top: 10px;
}
.left .tip {
  font-size: 11px;
  transform: scale(0.9);
  position: relative;
  left: -13px;
}
.content .wrapper .contentArea .right {
  width: 88px;
  height: 100%;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  right: 12px;
  top: 0px;
}
.right #headphoto {
  width: 84px;
  height: 115px;
}
.right .jobNum {
  font-size: 12px;
  transform: scale(0.9);
  position: relative;
  left: -3px;
  white-space: nowrap;
}
@media screen and (max-width: 320px) {
  .content .wrapper .logoArea .schoolLogo {
    width: 204px;
    height: 32px;
    background: url(../../../assets/zhicheng/schoolLogo.png) no-repeat center;
    background-size: auto 100%;
    margin-left: 0px;
    transform: scale(0.9);
    position: relative;
    left: -5px;
  }
  .content .wrapper .contentArea .left {
    padding-left: 8px;
  }
  .content .wrapper .contentArea .right {
    right: 3px;
  }
  .left .tip {
    font-size: 11px;
    -webkit-transform: scale(0.9);
    transform: scale(0.8);
    position: relative;
    left: -25px;
  }
}
</style>